import './PersonPage.css'
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet'
import MainLayout from "../../layouts/MainLayout/MainLayout";
import { useEffect, useState } from "react";
import axios from "axios";
import { notifications } from "@mantine/notifications";
import { Avatar, Badge, Center, Flex, Loader, Stack } from "@mantine/core";


export default function PersonPage() {
    const { name } = useParams()
    const [state, setState] = useState({
        isLoading: false,
        data: null,
        error: ''
    })

    const displayName = name
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    useEffect(() => {
        const getPersonInfo = async () => {
            try {
                setState(prev => ({ ...prev, isLoading: true }))
                const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/getPublicAboutUserInfo/${name}`

                const { data } = await axios.get(URL)
                setState(prev => ({ ...prev, data }))
            } catch (error) {
                setState(prev => ({ ...prev, error: error.message }))
                notifications.show({
                    message: error.message,
                    title: "Ha ocurrido un error",
                    color: 'red'
                })
            } finally {
                setState(prev => ({ ...prev, isLoading: false }))
            }
        }
        getPersonInfo()
    }, [name])


    return (
        <>
            <Helmet>
                <title>{displayName} | Forvet</title>
                <meta name="description" content={state?.data?.about?.description} />
                <meta property="og:title" content={displayName} />
                <meta property="og:description" content={state?.data?.about?.description} />
                <meta property="og:image" content={state?.data?.profilePicture} />
                <meta property="og:url" content={`https://forvet.org/profesores/${name}`} />
            </Helmet>
            <MainLayout >
                <section className='landing__section'>
                    {state.isLoading && <Center mih='50vh'>
                        <Loader />
                    </Center>
                    }
                    {state.error && state.error !== '' && <section className="PersonPage-error-container">
                        <h3 className="PersonPage-error-title">Ha ocurrido un error</h3>
                        <p >{state.error}</p>
                    </section>}
                    {state.data && !state.error && (state.data.about.personalItems?.length > 0 || state.data.about.description) && <section className="PersonPage-content-wrapper">
                        <PersonHeader {...state.data} />
                        <hr className='PersonPage--separation-line' />
                        <PersonInfo {...state.data.about} />
                    </section>}
                </section>
            </MainLayout>
        </>
    )
}


const PersonHeader = ({ name, lastname, profilePicture, type, nationality }) => {


    const renderType = (_type) => {
        if (!_type) return 'USUARIO'
        const value = _type.toLowerCase()

        if (value === 'teacher') return 'PROFESOR'
        if (value === 'staff') return 'STAFF'
        return "USUARIO"
    }

    return <section className="PersonHeader-main-container">
        <figure className='PersonHeader-main-container--image-container'>
            <Avatar
                size={100}
                src={profilePicture || null}
                alt={`${name} ${lastname}`}
            />
        </figure>
        <Stack gap={0}>
            <h1 className="PersonHeader--name">
                {`${name} ${lastname}`}

            </h1>
            <Flex gap={8}>
                <Badge>
                    {renderType(type)}
                </Badge>
                {nationality&& <Badge variant='outline' color='var(--color-text-primary)'>
                    {nationality}
                </Badge>}
            </Flex>
        </Stack>
    </section>
}
const PersonInfo = ({ personalItems, description }) => {
    // Agrupar por "item"
    const groupedItems = personalItems?.reduce((acc, current) => {
        const key = current.item;
        if (!acc[key]) acc[key] = [];
        acc[key].push(current.value);
        return acc;
    }, {});

    return (
        <section className='PersonInfo-main-container'>
            {description && (
                <div>
                    <h4 className='PersonInfo--title'>
                                <strong>Sobre mí</strong>
                            </h4>
                <p className='PersonInfo--description-text'>{description}</p>
                </div>
            )}

            {groupedItems && Object.keys(groupedItems).length > 0 && (
                <Stack>
                    {Object.entries(groupedItems).map(([label, values]) => {
                        const IS_OTHER_LABEL = label.toLowerCase() === 'otro'
                        return <>
                        {IS_OTHER_LABEL && <hr style={{opacity:.2}}/>}
                        <div key={label}>
                            
                          {!IS_OTHER_LABEL && <h4 className='PersonInfo--title'>
                                <strong>{label}</strong>
                            </h4>}
                            {values.map((value, index) => (
                                <p key={index} className='PersonInfo--description-text'>
                                    {value}
                                </p>
                            ))}
                        </div>
                        </>
                    })}
                </Stack>
            )}
        </section>
    );
};
